import script from "./AuthenticationRestoreDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthenticationRestoreDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AuthenticationRestoreDialog.vue?vue&type=style&index=0&id=604832d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604832d0"]])

export default __exports__